import { data } from '../../svg/Request/data';
import { makeIcon } from '../makeIcon';

export const Request = makeIcon(data, 'request', 'Request');

export default Request;
